// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AuthLogoutResponse

export type AuthLogoutApiResponse = {
	message: string;
};

export type AuthLogout = {
	message: string;
};

export function hydrateAuthLogout(data: AuthLogoutApiResponse): AuthLogout {
	return { ...data };
}